import { Component, OnInit } from '@angular/core';
import { PedidoServico } from './servicos/pedido/pedido.servico';
import { Pedido } from './model/pedido';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ConfiguracaoSistemaServico } from './servicos/configuracaoSistema/configuracaoSistema.servico';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';
  public origemPedido: number = 0;
  public ativar_spinner: boolean = false;
  public possuiPedido: boolean = false;
  public aceitaAutomatico: boolean = false;
  currentRoute: string;
  device: USBDevice | null = null;

  constructor(private pedidoServico: PedidoServico, private router: Router, private route: ActivatedRoute, private configuracaoSistemaServico: ConfiguracaoSistemaServico) {
    router.events.subscribe((event: NavigationEnd) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.url;
      }

    });
  }

  ngOnInit(): void {
    this.configuracaoSistemaServico.obterTodos()
      .subscribe(
        data => {
          if (data != null && data.length > 0) {
            data.forEach(config => {
              if (config.descricao == 'PermiteIntegracao' && config.valor == 'true') {
                this.iniciarVerificacaoIntegracao();
              }
            });
          }
        },
        err => {
          console.log(err.error);
        }
      );
    
  }

  async iniciarVerificacaoIntegracao() {
    let timerId = setInterval(() => {
      this.pesquisarPedidoIntegracao()
    }, 30000);
  }

  pesquisarPedidoIntegracao() {
    //if (this.currentRoute == "/consulta-entrega-pedido" || this.currentRoute == "/") {
    if (this.currentRoute.indexOf("/faz-pedido/") == -1 && this.currentRoute.indexOf("/-relatorio/") == -1) {
      
      var imprimirIfood = localStorage.getItem("imprimirIfoodAutomatico");
      var imprimirAnotaAi = localStorage.getItem("imprimirAnotaAiAutomatico");

      this.pedidoServico.verificarNovosPedidosIntegracao().subscribe(
        retorno => {
          if (retorno.possuiPedido) {
            this.origemPedido = retorno.origemPedido;
            this.possuiPedido = true;
            this.aceitaAutomatico = false;

            if (this.origemPedido == 2 && imprimirIfood == 'true') {
              this.aceitaAutomatico = true;

              $(() => {
                $('#pedidoAutomatico').toast('show');
                this.playAudio();
              });
              this.aceitarPedidoIntegracao();
            }
            else if (this.origemPedido == 3 && imprimirAnotaAi == 'true') {
              this.aceitaAutomatico = true;

              $(() => {
                $('#pedidoAutomatico').toast('show');
                this.playAudio();
              });
              this.aceitarPedidoIntegracao();
            }
            else {
              $(() => {
                //$('.toast').toast('show');
                $('#pedidoIntegracao').toast('show');
                this.playAudio();
              });
            }
          }
          else {
            this.possuiPedido = false;
            $(() => {
              $('#pedidoIntegracao').toast('hide');
            });
          }
        },
        erro => {
          console.log(erro);
          //this.msg= "Ocorreu um erro ao finalizar o pedido."
        }
      );
    }
  }

  public aceitarPedidoIntegracao() {
    this.ativar_spinner = true;

    this.pedidoServico.aceitarPedidoIntegracao().subscribe(
      pedido => {
        this.ativar_spinner = false;
        if (pedido != null) {
          this.imprimirPedido(pedido);
        }
        else {
          alert('Pedido já aceito por outro atendente.');
        }

        //this.possuiPedido = false;

        $(() => {
          $('#pedidoIntegracao').toast('hide');

          setTimeout(function () {
            this.possuiPedido = false;
            console.log('possuiPedido = false');
          }, 4000);
        });
      },
      erro => {
        console.log(erro);
        this.ativar_spinner = false;
        //this.msg= "Ocorreu um erro ao finalizar o pedido."
      }
    );
  }

  imprimirPedido(pedido: Pedido) {
    //while (this.pedidoServico.imprimindo) {
    //  await this.sleep(1000);
    //}

    this.aguardarSeTrue(() => this.pedidoServico.imprimindo, () => {
      this.pedidoServico.atualizaImpressao = true;
      this.pedidoServico.montarImpressaoPedido(pedido).subscribe(
        impressao => {
          this.pedidoServico.imprimirViaServico(impressao).subscribe(
            retorno => {
              console.log(retorno);
              this.pedidoServico.atualizaImpressao = false;
            },
            error => {
              console.log(error);
              this.pedidoServico.atualizaImpressao = false;
            }
          )
        },
        error => {
          console.log(error);
          this.pedidoServico.atualizaImpressao = false;
        }
      )
    });
  }

  aguardarSeTrue(variavel: () => boolean, callback: () => void) {
    const interval = setInterval(() => {
      if (!variavel()) {
        clearInterval(interval);
        callback(); // Continua a execução da função original
      }
    }, 2000); // Verifica a cada 2000ms
  }

  sleep(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  playAudio() {
    let audio = new Audio();
    if (this.origemPedido == 2)
      audio.src = "../assets/sound/ifood.mp3";
    else
      audio.src = "../assets/sound/whatsapp.mp3";

    audio.load();
    audio.play();
  }

  async testarImpressora() {
    alert('teste');
    debugger;
    try {
      this.device = await navigator.usb.requestDevice({
        filters: [{ vendorId: 0x04B8, productId: 0x0E03 }]
      });

      await this.device.open();
      await this.device.selectConfiguration(1);
      await this.device.claimInterface(0);

      console.log('Conectado à impressora:', this.device.productName);
    } catch (error) {
      console.error('Erro ao conectar:', error);
      alert(`Erro ao conectar à impressora: ${error.message}`);
    }
  }
}
